import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function CustomDialog({
  showDialog = false,
  setShowDialog,
  showActions = false,
  disableBackdropClick = true,
  actions,
  fullScreenOnMobile = true,
  children,
  dialogProps = {},
}: any) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = (_e: any, reason: any) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }
    setShowDialog(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreenOnMobile && fullScreen}
        open={showDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        {...dialogProps}
      >
        {children}
        {showActions && <DialogActions>{actions}</DialogActions>}
      </Dialog>
    </React.Fragment>
  );
}
